import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg, TriggerArg } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/HdpClickstreamEvents.ts';

const SAVE_HOME = defineHotpadsEvent({
  key: 'hdp.save_home',
  eventTypeId: '4804',
  eventTypeVersionId: '6',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackSaveHomeClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_save_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'save_home',
});

const UNSAVE_HOME = defineHotpadsEvent({
  key: 'hdp.unsave_home',
  eventTypeId: '5051',
  eventTypeVersionId: '5',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackUnSaveHomeClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_save_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'unsave_home',
});

const HIDE_HOME = defineHotpadsEvent({
  key: 'hdp.hide_home',
  eventTypeId: '5052',
  eventTypeVersionId: '3',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHideHomeFromHdpEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_hide_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'hide_home',
});

const UNHIDE_HOME = defineHotpadsEvent({
  key: 'hdp.unhide_home',
  eventTypeId: '5055',
  eventTypeVersionId: '3',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackUnhideHomeFromHdpEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_hide_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'unhide_home',
});

const BUILDING_PAY_PER_LINK = defineHotpadsEvent({
  key: 'hdp.building_pay_per_link',
  eventTypeId: '5056',
  eventTypeVersionId: '2',
  eventTemplateId: '285',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackBuildingPayPerLinkClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_open_pay_per_click',
    object: 'home_details_component|property_details',
  },
  semanticEvent: 'building_pay_per_link',
});

const LOWER_PPC_CLICK = defineHotpadsEvent({
  key: 'hdp.ppc_click_lower',
  eventTypeId: '5566',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackLowerPpcClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_open_pay_per_click',
    object: 'home_details_component|property_details',
  },
  semanticEvent: 'ppc_click_lower',
});

const UPPER_PPC_CLICK = defineHotpadsEvent({
  key: 'hdp.ppc_click_upper',
  eventTypeId: '5567',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackUpperPpcClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_open_pay_per_click',
    object: 'home_details_component|summary',
  },
  semanticEvent: 'ppc_click_upper',
});

const APPLY_NOW_CLICK = defineHotpadsEvent({
  key: 'hdp.apply_now_click',
  eventTypeId: '5572',
  eventTypeVersionId: '3',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackApplyNowClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_open_apply_now_interstitial',
    object: 'home_details_component|summary',
  },
  semanticEvent: 'apply_now_click_hdp',
});

const RENTAL_APP_PRE_START = defineHotpadsEvent({
  key: 'hdp.rental_application_pre_start',
  eventTypeId: '5573',
  eventTypeVersionId: '3',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackRentalAppPreStartEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_open_apply_now_form',
    object: 'home_details_component|application_interstitial',
  },
  semanticEvent: 'rental_application_pre_start',
});

const REPORT_HOME = defineHotpadsEvent({
  key: 'hdp.report_home',
  eventTypeId: '5715',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackReportHomeFromHdpEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_report_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'report_home',
});

const NEXT_HDP = defineHotpadsEvent({
  key: 'hdp.next',
  eventTypeId: '5716',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpNextClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_next_hdp',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'next_hdp',
});

const PREV_HDP = defineHotpadsEvent({
  key: 'hdp.previous',
  eventTypeId: '5717',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpPrevClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_prev_hdp',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'prev_hdp',
});

const SIMILAR_LISTING_CLICK = defineHotpadsEvent({
  key: 'hdp.similar_listing_click',
  eventTypeId: '5901',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpSimilarListingClickEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'property_card',
    object: 'home_details_component|similar_listings',
  },
  semanticEvent: 'similar_listing_click',
});

const PHOTO_GALLERY_OPEN = defineHotpadsEvent({
  key: 'hdp.open_photo_gallery',
  eventTypeId: '5993',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpPhotoGalleryOpenEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_open_gallery',
    object: 'home_details_component|photos',
  },
  semanticEvent: 'open_photo_player',
});

const SHARE_HOME = defineHotpadsEvent({
  key: 'hdp.share_home',
  eventTypeId: '5718',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackShareHomeEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'button_to_share_home',
    object: 'home_details_component|action_bar',
  },
  semanticEvent: 'share_home',
});

const NATIVE_SHARE = defineHotpadsEvent({
  key: 'hdp.native_share',
  eventTypeId: '5925',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpNativeShareEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'native_share_tray',
    object: 'home_details_component|share_options',
  },
  semanticEvent: 'native_share',
});

const COPY_SHARE_URL = defineHotpadsEvent({
  key: 'hdp.copy_share_url',
  eventTypeId: '5926',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpCopyShareUrlEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_copy_share_url',
    object: 'home_details_component|share_options',
  },
  semanticEvent: 'copy_url_share',
});

const TEXT_SHARE = defineHotpadsEvent({
  key: 'hdp.text_share',
  eventTypeId: '5927',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpTextShareEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_text_share_url',
    object: 'home_details_component|share_options',
  },
  semanticEvent: 'text_share',
});

const EMAIL_SHARE = defineHotpadsEvent({
  key: 'hdp.email_share',
  eventTypeId: '5928',
  eventTypeVersionId: '2',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackHdpEmailShareEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_email_share_url',
    object: 'home_details_component|share_options',
  },
  semanticEvent: 'email_share',
});

const COSTS_AND_FEES_MODAL_OPEN = defineHotpadsEvent({
  key: 'hdp.costs_and_fees_modal_open',
  eventTypeId: '7679',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackCostsAndFeesModalOpenEvent',
  trigger: {
    type: 'interaction',
    location: 'home_details',
    source: 'link_to_open_cost_and_fees',
    object: 'home_details_component|summary',
  },
  semanticEvent: 'cost_and_fees_cta_click',
});

export function emitTrackSaveHomeClickEvent({ listing, triggerLocation, triggerObject }: ListingArg & TriggerArg) {
  trackHotpadsEventDefinition(SAVE_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackUnSaveHomeClickEvent({ listing, triggerLocation, triggerObject }: ListingArg & TriggerArg) {
  trackHotpadsEventDefinition(UNSAVE_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackHideHomeFromHdpEvent({
  listing,
  triggerLocation,
  triggerObject,
}: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(HIDE_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackUnhideHomeFromHdpEvent({
  listing,
  triggerLocation,
  triggerObject,
}: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(UNHIDE_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackBuildingPayPerLinkClickEvent({
  listing,
  triggerObject,
  triggerLocation,
}: ListingArg & TriggerArg) {
  trackHotpadsEventDefinition(BUILDING_PAY_PER_LINK, { listing, triggerLocation, triggerObject });
}

export function emitTrackLowerPpcClickEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(LOWER_PPC_CLICK, { listing, triggerLocation });
}

export function emitTrackUpperPpcClickEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(UPPER_PPC_CLICK, { listing, triggerLocation });
}

export function emitTrackApplyNowClickEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(APPLY_NOW_CLICK, { listing, triggerLocation });
}

export function emitTrackRentalAppPreStartEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(RENTAL_APP_PRE_START, { listing, triggerLocation });
}

export function emitTrackReportHomeFromHdpEvent({
  listing,
  triggerLocation,
  triggerObject,
}: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(REPORT_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackHdpNextClickEvent({ listing }: ListingArg = {}) {
  trackHotpadsEventDefinition(NEXT_HDP, { listing });
}

export function emitTrackHdpPrevClickEvent({ listing }: ListingArg = {}) {
  trackHotpadsEventDefinition(PREV_HDP, { listing });
}

export function emitTrackHdpSimilarListingClickEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(SIMILAR_LISTING_CLICK, { listing, triggerLocation });
}

export function emitTrackHdpPhotoGalleryOpenEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(PHOTO_GALLERY_OPEN, { listing, triggerLocation });
}

export function emitTrackShareHomeEvent({ listing, triggerLocation, triggerObject }: ListingArg & TriggerArg) {
  trackHotpadsEventDefinition(SHARE_HOME, { listing, triggerLocation, triggerObject });
}

export function emitTrackHdpNativeShareEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(NATIVE_SHARE, { listing, triggerLocation });
}

export function emitTrackHdpCopyShareUrlEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(COPY_SHARE_URL, { listing, triggerLocation });
}

export function emitTrackHdpTextShareEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(TEXT_SHARE, { listing, triggerLocation });
}

export function emitTrackHdpEmailShareEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(EMAIL_SHARE, { listing, triggerLocation });
}

export function emitTrackCostsAndFeesModalOpenEvent({ listing, triggerLocation }: ListingArg & TriggerArg = {}) {
  trackHotpadsEventDefinition(COSTS_AND_FEES_MODAL_OPEN, { listing, triggerLocation });
}
